<script lang="ts">
  import { signupStore } from "$app/signupstore.svelte"
  import { appStore } from "$app/store.svelte"
</script>

{#if signupStore.subscription.subscription_type === "free"}
  <div class="flex flex-col justify-center items-center">
    <span
      class="text-gray-700 mt-4 text-center bg-gray-50 py-2 px-4 rounded shadow"
      style="text-wrap: balance"
    >
      You have used <strong>{appStore.users.length}</strong>
      out of
      <strong>{signupStore.totalSeats}</strong> seats for your subscription.
    </span>
    {#if appStore.users.length >= signupStore.totalSeats}
      <span class="text-gray-600 text-sm mt-3 text-center py-1 px-3 italic">
        To add more members, upgrade to the Standard Subscription.
      </span>
    {/if}
  </div>
{:else if signupStore.subscription.subscription_type === "standard"}
  <div class="flex flex-col justify-center border border-gray-200 rounded p-2">
    <p class="text-sm text-center font-bold">Standard Subscription Usage</p>
    <div class="flex justify-center items-center gap-x-4 mt-2">
      <div
        class="box bg-full-access-lt text-full-access-dk ring-full-access-md/10"
      >
        {signupStore.membersCount("full_access")} of {signupStore.subscription
          .full_access_total} Full-Access Members
      </div>
      <div
        class="box bg-team-member-lt text-team-member-dk ring-team-member-md/10"
      >
        {signupStore.membersCount("team_member")} of {signupStore.subscription
          .team_member_total} Team Members
      </div>
      <div
        class="box bg-recognition-lt text-recognition-dk ring-recognition-md/10"
      >
        {signupStore.membersCount("recognition_member")} of {signupStore
          .subscription.recognition_member_total}
        Recognition Members
      </div>
    </div>
  </div>
  {#if signupStore.availableSeats > 0}
    <div class="mt-2 flex justify-center">
      <span
        class="text-amber-800 text-sm mt-4 text-center bg-amber-100 py-1 px-3 rounded shadow font-bold"
      >
        To add more members, click Edit Subscription to add more seats.
      </span>
    </div>
  {/if}
{:else if signupStore.subscription.subscription_type === "unlimited"}
  <div class="mt-2 flex justify-center">
    <span
      class="text-blue-700 mt-4 text-center bg-blue-100 py-1 px-3 rounded shadow"
    >
      You have <strong>unlimited</strong> members available for your subscription.
    </span>
  </div>
{/if}

<style lang="postcss">
  @reference "tailwindcss";
  .box {
    @apply rounded-md flex justify-center items-center px-2 py-1 text-xs font-medium ring-1 ring-inset;
    flex-wrap: wrap;
    height: auto;
    align-self: stretch;
  }
</style>
